import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

// ================= GET GROCERY BILLING =================
export const getGroceryBillingAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Auth token missing. Please login again."
                );
            }

            const response =
                await axios.get(
                    `${BASE_URL}/groceries/api/admin/grocery/billing/get`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data || {};

        } catch (error) {
            console.error(
                "❌ Error fetching billing data:",
                error
            );

            throw error;
        }
    };

// ================= SAVE / UPDATE GROCERY BILLING =================
export const saveGroceryBillingAPI =
    async (billingData) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Missing token — please login again."
                );
            }

            // Build payload
            const payload = {
                id:
                    billingData.id ||
                    undefined,

                commission:
                    Number(
                        billingData.commission ||
                        0
                    ),

                commissionGst:
                    Number(
                        billingData.commissionGst ||
                        0
                    ),

                gst:
                    Number(
                        billingData.gst ||
                        0
                    ),

                platformFee:
                    Number(
                        billingData.platformFee ||
                        0
                    ),

                deliveryFeePerKm:
                    Number(
                        billingData.deliveryFeePerKm ||
                        0
                    ),

                partialPayment:
                    Number(
                        billingData.partialPayment ||
                        0
                    ),

                leadPercentage:
                    Number(
                        billingData.leadPercentage ||
                        0
                    ),

                couponAmount:
                    Number(
                        billingData.couponAmount ||
                        0
                    ),

                topRated:
                    Number(
                        billingData.topRated ||
                        0
                    ),

                // Boolean fields
                commissionApplicable:
                    billingData.commissionApplicable ||
                    false,

                commissionGstApplicable:
                    billingData.commissionGstApplicable ||
                    false,

                gstApplicable:
                    billingData.gstApplicable ||
                    false,

                platformFeeApplicable:
                    billingData.platformFeeApplicable ||
                    false,

                deliveryFeePerKmApplicable:
                    billingData.deliveryFeePerKmApplicable ||
                    false,

                partialPaymentApplicable:
                    billingData.partialPaymentApplicable ||
                    false,

                leadPercentageApplicable:
                    billingData.leadPercentageApplicable ||
                    false,
            };

            const isUpdate =
                !!billingData.id;

            const url =
                isUpdate
                    ? `${BASE_URL}/groceries/api/admin/grocery/billing/update`
                    : `${BASE_URL}/groceries/api/admin/grocery/billing/create`;

            const method =
                isUpdate
                    ? axios.put
                    : axios.post;

            const response =
                await method(
                    url,
                    payload,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            return {
                success: true,

                data:
                    response.data,

                isUpdate,
            };

        } catch (error) {
            console.error(
                "❌ Save failed:",
                error.response?.data ||
                error.message
            );

            throw error;
        }
    };



export const getAllGroceryOrdersAPI =
    async (signal) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const headers =
                token
                    ? {
                        Authorization:
                            `Bearer ${token}`,
                    }
                    : {};

            const response =
                await fetch(
                    `${BASE_URL}/groceries/api/admin/grocery/orders/all`,
                    {
                        headers,

                        signal,
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status}`
                );
            }

            const fetchedApiData =
                await response.json();

    
            // Normalize response
            const normalized =
                Array.isArray(
                    fetchedApiData
                )
                    ? fetchedApiData
                    : fetchedApiData.data ||
                    [];

            return normalized;

        } catch (error) {
            console.error(
                "❌ Fetching grocery orders error:",
                error
            );

            throw error;
        }
    };

export const getAllGrocerySettlementsAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "No auth token found. Please login first."
                );
            }

            const response =
                await axios.get(
                    `${BASE_URL}/groceries/api/admin/settlements/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            Accept:
                                "*/*",
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error fetching grocery settlements:",
                error
            );

            throw error;
        }
    };

// ================= APPROVE GROCERY SETTLEMENT =================
export const approveGrocerySettlementAPI =
    async (settlementId) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Token not found! Please log in again."
                );
            }

            const response =
                await axios.put(
                    `${BASE_URL}/groceries/api/admin/settlements/update-status/${settlementId}?paymentStatus=SUCCESS`,
                    {},
                    {
                        headers: {
                            accept:
                                "*/*",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error approving grocery settlement:",
                error
            );

            throw error;
        }
    };

// ================= GENERATE GROCERY RANGE =================
export const generateGroceryRangeAPI =
    async (
        fromDate,
        toDate
    ) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Token not found! Please log in again."
                );
            }

            if (
                !fromDate ||
                !toDate
            ) {
                throw new Error(
                    "Please select both From and To dates"
                );
            }

            const response =
                await axios.post(
                    `${BASE_URL}/groceries/api/admin/generate-range?fromDate=${fromDate}&toDate=${toDate}`,
                    {},
                    {
                        headers: {
                            accept:
                                "*/*",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error generating grocery range:",
                error
            );

            throw error;
        }
    };

export const getGroceryRefundHistoryAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Authentication token not found. Please login again."
                );
            }

            const response =
                await axios.get(
                    `${BASE_URL}/groceries/api/admin/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            if (
                !Array.isArray(
                    response.data
                )
            ) {
                throw new Error(
                    "Unexpected response format"
                );
            }

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error fetching grocery refund history:",
                error
            );

            throw error;
        }
    };
export const fetchAllOrders = async (signal) => {
    const token = localStorage.getItem("authToken");

    const headers = {
        "Content-Type": "application/json",
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${BASE_URL}/groceries/api/admin/grocery/orders/all`, {
        method: "GET",
        headers,
        signal,
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    return Array.isArray(result)
        ? result
        : result.data || [];
};



// ================= SAVE / UPDATE SUBSCRIPTION PLANS =================
export const saveSubscriptionPlansAPI =
    async (
        plans,
        planType,
        API_KEY
    ) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const savedPlans =
                [];

            for (let plan of plans) {

                const payload = {
                    price:
                        Number(
                            plan.price
                        ) || 0,

                    businessModules:
                        plan.businessModules ||
                        [],

                    planType,

                    businessVerticals:
                        "FRESH_GROCERIES",

                    days:
                        plan.days,
                };

                const headers = {
                    "Content-Type":
                        "application/json",

                    "X-API-Key":
                        API_KEY,

                    ...(token && {
                        Authorization:
                            `Bearer ${token}`,
                    }),
                };

                const response =
                    await fetch(
                        plan.id
                            ? `${BASE_URL}/subscription/api/admin/plans/update/${plan.id}`
                            : `${BASE_URL}/subscription/api/admin/plans/add`,
                        {
                            method:
                                plan.id
                                    ? "PUT"
                                    : "POST",

                            headers,

                            body:
                                JSON.stringify(
                                    payload
                                ),
                        }
                    );

                if (!response.ok) {

                    const errorData =
                        await response
                            .json()
                            .catch(() => ({}));

                    throw new Error(
                        errorData.message ||
                        `Failed saving plan ${plan.days} days`
                    );
                }

                const savedPlan =
                    await response.json();

                savedPlans.push(
                    savedPlan
                );
            }

            return savedPlans;

        } catch (error) {

            console.error(
                "❌ Error saving subscription plans:",
                error
            );

            throw error;
        }
    };

// ================= GET SUBSCRIPTION PLANS BY VERTICAL =================
export const getSubscriptionPlansByVerticalAPI =
    async (API_KEY) => {

        try {

            const response =
                await fetch(
                    `${BASE_URL}/subscription/api/get/vertical/FRESH_GROCERIES`,
                    {
                        method: "GET",

                        headers: {
                            "X-API-Key":
                                API_KEY,

                            Accept:
                                "application/json",
                        },
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP error: ${response.status}`
                );
            }

            const data =
                await response.json();

            return data;

        } catch (error) {

            console.error(
                "❌ Fetch subscription plans failed:",
                error
            );

            throw error;
        }
    };